import React from 'react';
interface GenericAccordianProps {
    children?: React.ReactNode;
}

const GenericAccordian = (props: GenericAccordianProps) => <div>{props.children}</div>;
export default GenericAccordian;
